import styled from 'styled-components'
import { useTranslation } from 'react-i18next'
import { Anchor } from '@/components/anchor'
import { breakpoints, colors, fontWeights, fontSizes } from '@/styles'
import { ButtonBar } from '@/components/button-bar'
import ContentWrapper from '@/components/content-wrapper'
import Panel from '@/components/panel'
import AreaTitle from '@/components/area-title'
import PageTitle from '@/components/page-title'
export const StyledContentWrapper = styled(ContentWrapper)<{ isModal?: boolean }>`
  margin-bottom: 100px;

  ${props =>
    props.isModal &&
    `
    margin: 0;
    max-width: unset;
    padding: 0 32px;

    @media screen and (max-width: ${breakpoints.phoneMax}) {
      padding: 0 24px;
    }
  `}
`
export const StyledPanel = styled(Panel)<{ isModal?: boolean }>`
  padding: 32px;

  ${props =>
    props.isModal &&
    `
    padding: 0;
  `}
`

export const StyledAreaTitle = styled(AreaTitle)<{ isModal?: boolean }>`
  ${props =>
    props.isModal &&
    `
   margin-top: 24px;
  `}
`

export const StyledButtonBar = styled(ButtonBar)<{ isModal?: boolean }>`
  ${props =>
    props.isModal &&
    `
    height: auto;
    padding: 4px 8px 24px;
    border-top: none;
    z-index: unset;
    background: none;

    @media screen and (max-width: ${breakpoints.phoneMax}) {
      padding-bottom: 16px;
    }
  `}
`

export const DataRow = styled.div`
  display: flex;
  justify-content: space-between;
  margin: 20px 0;

  p {
    font-size: ${fontSizes.regular};
    font-weight: ${fontWeights.regular};
    margin: 0;
  }

  strong {
    font-weight: ${fontWeights.medium};
  }
`

export const TextRow = styled.div`
  margin: 20px 0;

  p {
    font-size: ${fontSizes.regular};
    font-weight: ${fontWeights.regular};
    margin: 0;
    letter-spacing: -0.39px;
    line-height: 20px;
  }

  ul {
    padding-inline-start: 20px;
    margin-block-start: 20px;
    margin-block-end: 30px;

    li {
      margin: 20px 0;
    }
  }
`

export const WarningRow = styled(TextRow)<{ marginTop?: number; marginBottom?: number }>`
  margin-top: ${props => `${props.marginTop}px` ?? '30px'};
  margin-bottom: ${props => `${props.marginBottom}px` ?? 'unset'};
  color: #dc0027;
`

export const CheckboxText = styled.label`
  letter-spacing: -0.39px;
  line-height: 22px;

  strong {
    font-weight: ${fontWeights.medium};
  }
`

export const StyledAnchor = styled(Anchor)`
  letter-spacing: -0.39px;
  line-height: 22px;
  color: ${colors.link};
  text-decoration: underline;
`

export const DirectDepositPageTitle = () => {
  const { t } = useTranslation()
  return (
    <PageTitle>{t('l.payment_settings.view.direct_deposit.title', 'Direct Deposit')}</PageTitle>
  )
}
